import { useDropzone } from "react-dropzone";
import {
  Box,
  Checkbox,
  DataGrid,
  Grid,
  Tooltip,
  Typography,
} from "../../../components";
import { useEffect, useRef, useState } from "react";
import { value } from "../../../helpers";
import { erroCelulaGridProdutos } from "../importar-produto";
import {
  FamiliaProdutosService,
  GrupoProdutosService,
  GruposTributarioService,
  OrigemMercadoriaService,
  SubfamiliaProdutosService,
  SubgrupoProdutosService,
  TiposItemService,
  UnidadeComercialService,
} from "../../../services";
import { formatPrice, responseErros } from "../../../utils";

const gruposTributarioService = new GruposTributarioService();
const grupoProdutosService = new GrupoProdutosService();
const subgrupoProdutosService = new SubgrupoProdutosService();
const familiaProdutosService = new FamiliaProdutosService();
const subfamiliaProdutosService = new SubfamiliaProdutosService();
const unidadeComercialService = new UnidadeComercialService();
const origemMercadoriaService = new OrigemMercadoriaService();
const tiposItemService = new TiposItemService();

const ImportarProdutoStepper = ({
  activeStep,
  arquivoCsv,
  setArquivoCsv,
  dadosCsv,
  inputErros,
}) => {
  const [gruposTributarios, setGruposTributarios] = useState([]);
  const [gruposProdutos, setGruposProdutos] = useState([]);
  const [subgruposProdutos, setSubgruposProdutos] = useState([]);
  const [familiaProdutos, setFamiliaProdutos] = useState([]);
  const [subfamiliaProdutos, setSubfamiliaProdutos] = useState([]);
  const [listaUnidadesComerciais, setListaUnidadesComerciais] = useState([]);
  const [origensMercadorias, setOrigensMercadorias] = useState([]);
  const [tiposItem, setTiposItem] = useState([]);

  const csvUpload = useRef(null);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: [
      "text/csv",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
    onDrop: (acceptedFiles) => {
      handleCsvChange(acceptedFiles);
    },
  });

  function handleCsvChange(event) {
    if (event.target) {
      setArquivoCsv(event.target.files[0]);
    } else {
      setArquivoCsv(event[0]);
    }
  }

  const colunasProdutos = [
    {
      field: "codigoBarra",
      headerName: "Código de Barra",
      sortable: false,
      width: 200,
    },
    {
      field: "descricao",
      headerName: "Produto",
      sortable: false,
      width: 400,
    },
    {
      field: "grupoProdutoId",
      headerName: "Grupo de Produto",
      sortable: false,
      width: 300,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        value.autoComplete(gruposProdutos, params.value)?.descricao,
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "subgrupoProdutoId",
      headerName: "Subgrupo de Produto",
      sortable: false,
      width: 300,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        value.autoComplete(subgruposProdutos, params.value)?.descricao,
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "familiaProdutoId",
      headerName: "Família de Produto",
      sortable: false,
      width: 300,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        value.autoComplete(familiaProdutos, params.value)?.descricao,
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "subfamiliaProdutoId",
      headerName: "Subfamília de Produto",
      sortable: false,
      width: 300,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        value.autoComplete(subfamiliaProdutos, params.value)?.descricao,
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "grupoTributacaoId",
      headerName: "Grupo Tributário",
      sortable: false,
      width: 300,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        value.autoComplete(gruposTributarios, params.value)?.nome,
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "unidadeComercialCompraId",
      headerName: "Unid. Compra",
      sortable: false,
      width: 180,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        value.autoComplete(listaUnidadesComerciais, params.value)?.descricao,
    },
    {
      field: "unidadeComercialVendaId",
      headerName: "Unid. Venda",
      sortable: false,
      width: 180,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        value.autoComplete(listaUnidadesComerciais, params.value)?.descricao,
    },
    {
      field: "fracionavel",
      headerName: "Fracionavel",
      sortable: false,
      width: 120,
      renderCell: (params) => (
        <Checkbox
          color="primary"
          disabled
          checked={params.value === "true"}
          className="ms-4"
        />
      ),
    },
    {
      field: "ncmId",
      headerName: "NCM",
      sortable: false,
      width: 120,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.row?.ncmCodigo,
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "cestId",
      headerName: "CEST",
      sortable: false,
      width: 120,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.row?.cestCodigo,
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "origemMercadoriaId",
      headerName: "Origem da Mercadoria",
      sortable: false,
      width: 450,
      valueGetter: (params) =>
        value.autoComplete(origensMercadorias, params.value)?.descricao,
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "tipoItemId",
      headerName: "Tipo de Item",
      sortable: false,
      width: 350,
      valueGetter: (params) =>
        value.autoComplete(tiposItem, params.value)?.descricao,
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "precoCompra",
      headerName: "Preço Compra",
      sortable: false,
      headerAlign: "right",
      align: "right",
      width: 200,
      valueGetter: (params) => formatPrice(params.value),
    },
    {
      field: "precoCusto",
      headerName: "Preço Custo",
      sortable: false,
      headerAlign: "right",
      align: "right",
      width: 200,
      valueGetter: (params) => formatPrice(params.value),
    },
    {
      field: "precoVenda",
      headerName: "Preço Venda",
      sortable: false,
      headerAlign: "right",
      align: "right",
      width: 200,
      valueGetter: (params) => formatPrice(params.value),
    },
  ];

  useEffect(() => {
    buscarGruposTributario();
    buscarGruposProdutos();
    buscarSubGruposProdutos();
    buscarFamiliaProdutos();
    buscarSubfamiliaProdutos();
    buscarUnidadesComerciais();
    buscarOrigensMercadoria();
    buscarTiposItem();
  }, []);

  const renderCellTratamentoErros = (params) => {
    return erroCelulaGridProdutos(params, inputErros) ? (
      <Tooltip
        title={`${params.colDef.headerName} é obrigatório`}
        arrow
        placement="top"
      >
        <i
          className="ph ph-warning"
          style={{ fontSize: 26, color: "#e53935" }}
        />
      </Tooltip>
    ) : (
      params.formattedValue
    );
  };

  const buscarGruposTributario = () => {
    gruposTributarioService
      .getAll({
        ativado: true,
        nonPaginated: true,
      })
      .then((result) => {
        if (!result.isAxiosError) {
          if (result.data) {
            setGruposTributarios(result.data);
          }
        } else {
          responseErros(result);
        }
      });
  };

  const buscarOrigensMercadoria = () => {
    origemMercadoriaService.getAll().then((res) => {
      if (!res.isAxiosError) {
        setOrigensMercadorias(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarTiposItem = () => {
    tiposItemService.getAll().then((res) => {
      if (!res.isAxiosError) {
        setTiposItem(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarGruposProdutos = () => {
    grupoProdutosService
      .getAll({
        ativado: true,
        nonPaginated: true,
      })
      .then((result) => {
        if (!result.isAxiosError) {
          setGruposProdutos(result.data);
        } else {
          responseErros(result);
        }
      });
  };

  const buscarSubGruposProdutos = () => {
    subgrupoProdutosService
      .getAll({
        ativado: true,
        nonPaginated: true,
      })
      .then((result) => {
        if (!result.isAxiosError) {
          setSubgruposProdutos(result.data);
        } else {
          responseErros(result);
        }
      });
  };

  const buscarFamiliaProdutos = () => {
    familiaProdutosService
      .getAll({
        ativado: true,
        nonPaginated: true,
      })
      .then((result) => {
        if (!result.isAxiosError) {
          setFamiliaProdutos(result.data);
        } else {
          responseErros(result);
        }
      });
  };

  const buscarSubfamiliaProdutos = () => {
    subfamiliaProdutosService
      .getAll({
        ativado: true,
        nonPaginated: true,
      })
      .then((result) => {
        if (!result.isAxiosError) {
          setSubfamiliaProdutos(result.data);
        } else {
          responseErros(result);
        }
      });
  };

  const buscarUnidadesComerciais = () => {
    unidadeComercialService.getAll().then((res) => {
      if (!res.isAxiosError) {
        setListaUnidadesComerciais(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  switch (activeStep) {
    case 1:
      return (
        <Grid container spacing={2} sx={{ pl: 2, mt: 3 }}>
          <DataGrid
            rows={dadosCsv || []}
            columns={colunasProdutos}
            rowCount={dadosCsv?.length || 0}
            disableAcoes
          />
        </Grid>
      );
    default:
      return (
        <Box
          {...getRootProps()}
          sx={{
            width: "100%",
            height: "90%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "1em",
            border:
              isDragActive || arquivoCsv
                ? "2px dashed grey"
                : "2px solid transparent",
            borderRadius: 2,
            padding: 2,
            backgroundColor: isDragActive || arquivoCsv ? "#e3f2fd" : "#fafafa",
            ":hover": { backgroundColor: "#e3f2fd", border: "2px dashed grey" },
            cursor: "pointer",
          }}
          onClick={() => csvUpload.current.click()}
        >
          <input
            {...getInputProps()}
            type="file"
            style={{ display: "none" }}
            ref={csvUpload}
            onChange={(event) => handleCsvChange(event.target.files)}
          />
          {arquivoCsv && (
            <i
              className="mb-2 ph-bold ph-check-circle"
              style={{ fontSize: 50, color: "#43a047" }}
            />
          )}
          <h4 style={{ fontWeight: 800, margin: 0 }}>
            {arquivoCsv
              ? "Arquivo Selecionado!"
              : "Arraste e solte ou Clique aqui para importar arquivo CSV/XLS"}
          </h4>
          {arquivoCsv?.name && (
            <div className="mt-2">
              <Typography>{arquivoCsv.name}</Typography>
            </div>
          )}
        </Box>
      );
  }
};

export default ImportarProdutoStepper;
